























import { defineComponent } from '@vue/composition-api';

import { BASE_DRIVER } from '@/useDeliveryNote';
import useAuth from '@/useAuth';

const DeliveryOnMap = defineComponent({
  props: {
    driver: {
      default() {
        return { ...BASE_DRIVER };
      },
    },
    vehicle: {
      default() {
        return {
          license: '',
          province: '',
          model: '',
          color: '',
          year: '',
        };
      },
    },
  },
  setup() {
    const { me } = useAuth();

    return {
      me,
    };
  },
});

export default DeliveryOnMap;
